import {
  Injectable
} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target ? : boolean;
  name: string;
  type ? : string;
  children ? : ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label ? : string;
  main_state ? : string;
  target ? : boolean;
  name: string;
  type: string;
  icon: string;
  badge ? : BadgeItem[];
  children ? : ChildrenItems[];
}

export interface Menu {
  label: string;
  role: string[];
  main: MainMenuItems[];

}

const MENUITEMS = [{
    label: '',
    role: ['Admin'],
    main: [{
      state: 'actiontracker',
      short_label: 'D',
      name: 'Action Tracker',
      type: 'link',
      icon: 'ti-write'
    }],
  },



  {
    label: '',
    role: ['Admin'],
    main: [{
      state: 'rfq',
      short_label: 'D',
      name: 'RFQs',
      type: 'sub',
      icon: 'ti-write',
      children: [{
          state: 'allrfq',
          name: 'RFQ List'
        },
        {
          state: 'rfqTracker',
          name: ' RFQ Tracker',

        },
        {
          state: 'directoryrfqs',
          name: ' Directory RFQs',

        }
      ]
    }],
  },
  {
    label: '',
    role: ['Admin'],
    main: [{
      state: 'buyer',
      short_label: 'D',
      name: 'Buyers',
      type: 'sub',
      icon: 'ti-write',
      children: [{
        state: 'buyerList',
        name: 'Buyer List'
      }]
    }],
  },
  {
    label: '',
    role: ['Admin'],
    main: [{
      state: 'manufacturer',
      short_label: 'D',
      name: 'Manufacturer',
      type: 'sub',
      icon: 'ti-write',
      children: [{
          state: 'manufacturerlist',
          name: 'Manufacturer List'
        },
        {
          state: 'spotlight',
          name: 'Spotlight'
        }
      ]
    }],
  },
  {
    label: '',
    role: ['Admin'],
    main: [{
      state: 'default',
      short_label: 'D',
      name: 'Engineering',
      type: 'link',
      icon: 'ti-hummer'
    }],
  },

  {
    label: '',
    role: ['Admin'],
    main: [{
      state: 'messages',
      short_label: 'D',
      name: 'Message',
      type: 'link',
      icon: 'ti-email'
    }],
  },
];

@Injectable()
export class MenuItems {
  role: string;
  count1: number;
  getAll(): Menu[] {
    this.role = '';
    this.count1 = 111;
    this.role = localStorage.getItem('Usertype');
    // return MENUITEMS.filter( x => x.role.includes(this.role));
    return MENUITEMS;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-items/menu-items.ts